// Vue 3 removed $on/$off/$once from every component instance (including
// $root), which this app relied on heavily as a global event bus
// (`this.$root.$emit(...)` / `this.$root.$on(...)`). This tiny mitt-based
// bus is the drop-in replacement: call bus.emit(name, ...args) instead of
// root.$emit(name, ...args), and bus.on(name, handler) instead of
// this.$root.$on(name, handler).
//
// Note: handlers registered with bus.on() in a component's created()/mounted()
// are not automatically removed - this matches the previous $root.$on()
// behavior (which never cleaned up either), so there's no behavior change,
// just a like-for-like swap of the underlying mechanism.
import mitt from 'mitt'

export const bus = mitt()
